document.addEventListener('DOMContentLoaded', function() {
	let lazyLoadInstance;
	let minicart;
	init();
});

function init() {
	let body = document.querySelector('body');
	let buttonToggles = document.querySelectorAll('[data-toggle]');
	
	// LazyLoad
	lazyLoadInstance = new LazyLoad({
		elements_selector : '.lazyload',
        callback_loaded: (media) => {
          if ( media.dataset.type == 'hero-background') {
            // Layout Hero Background : Trigger loading 
            gsap.to('.fade-in', {
                y: 0,
                opacity: 1,
                stagger: 0.2,
                duration: 1,
            });
          }
        }
	});
	
	// Toggle Class
	buttonToggles.forEach((button, i) => {
		button.addEventListener('click', (event) => {
			body.classList.toggle(button.getAttribute('data-toggle'));
		});
	});

	// Theme Preview
	if (Shopify.designMode) {
		document.addEventListener("shopify:section:reorder", function () {
			lazyLoadInstance.update();
		});
		document.addEventListener("shopify:section:load", function () {
			lazyLoadInstance.update();
		});
	}

	
    // Layouts
	layout_hero();
    layout_video();
    layout_product();
	layout_quantity();
	layout_about();
	layout_collection();

	layout_product_feature();
	layout_minicart();

	// Header
	header();
}

function header() {

    // GSAP
    gsap.registerPlugin(ScrollTrigger)
  	let header = document.querySelector('.header');
    let mm = gsap.matchMedia();

    // Header Animation : Desktop only
    mm.add("(min-width: 769px)", () => {
    
    	// Header Animation
    	let tl = gsap.timeline({
    		scrollTrigger: {
    			trigger: '.header',
    			pin: false, // pin the trigger element while active
    			start: 'top top', 
    			end: '+=200',
    			scrub: 1,
    			markers : false,
    		}
    	});
    	// add animations and labels to the timeline
    	tl.addLabel('start')
    		.to('.header-logo', { x: '-100%', opacity: 0, ease: "none", duration: 1 }, 'start')
    		.to('.header-menu', { x: -352, ease: "none", duration: 3 }, 'start')
    		.to('.header', { backgroundColor: '#F7F1E8', color: '#000000', height:50, ease: "none", duration: 3 }, 'start')
    		.to('.header-logo-marque', { opacity:1, ease: "none", duration: 1 }, 1.5);
    
      return () => { // optional
        // custom cleanup code here (runs when it STOPS matching)
      };
    });
  

	// Button : Menu
	let body = document.querySelector('body');
	let buttonMenu = document.querySelector('.button-show-menu');
	let minicartElement = document.querySelector('.layout-minicart');

	buttonMenu.addEventListener('click', (event) => {
		if ( body.classList.contains('show-minicart') ) {
			// Mobile : Button closes the minicart
			body.classList.remove('show-minicart');
			minicartElement._dialog.hide();
		} else if ( body.classList.contains('show-menu') ) {
			// Menu : Close
			body.classList.remove('show-menu');
		} else {
			// Menu : Open
			body.classList.add('show-menu');
		} 
	});

    // Menu : Hover
    let menu = document.querySelector('.header-menu');  
    let menuItems = document.querySelectorAll('.header-menu-item');
    
    menuItems.forEach((menuItem, i) => {
      menuItem.addEventListener('mouseover', (event) => {
        menu.classList.add('is-hover');
      });
    });

    menu.addEventListener('mouseout', (event) => {
      menu.classList.remove('is-hover');
    });

    // Submenu
    let menuSubmenuItems = document.querySelectorAll('.header-menu-item.has-submenu > a'); 
    menuSubmenuItems.forEach((menuSubmenuItem, i) => {
      menuSubmenuItem.addEventListener('click', (event) => {
        event.preventDefault();
        if ( menuSubmenuItem.parentElement.classList.contains('is-active') ) {
          menuSubmenuItem.parentElement.classList.remove('is-active');
          header.classList.remove('has-submenu-active');
        } else {
          menuSubmenuItem.parentElement.classList.add('is-active');
          header.classList.add('has-submenu-active');
        }
      });
    });

	// Button : Search
	let searchElement = document.querySelector('.layout-search-form');
	let searchModal = new A11yDialog(searchElement);
	let searchModalOpen = false;
	let headerMenuSearch = document.querySelector('.header-menu-search');

	headerMenuSearch.addEventListener('click', (event) => {
		event.preventDefault();
		if ( !searchModalOpen ) {
			searchModal.show();
		} else {
			searchModal.hide();
		}
	});

	searchModal.on('show', function (event) {
		searchModalOpen = true;
		body.classList.add('show-search');
	});
	searchModal.on('hide', function (event) {
		searchModalOpen = false;
		body.classList.remove('show-search');
	});
}

function layout_product_feature() {
	let productFeatures = document.querySelectorAll('.layout-product-feature');

	productFeatures.forEach((productFeature, i) => {
		let swiper = new Swiper(productFeature, {
			direction: 'horizontal',
			loop: false,
			navigation: {
				nextEl: productFeature.querySelector('.swiper-button-next'),
				prevEl: productFeature.querySelector('.swiper-button-prev'),
			}
		});
	});
}

function layout_minicart() {
	let minicartElement = document.querySelector('.layout-minicart');
	let minicart = new A11yDialog(minicartElement);
	let headerMenuMinicart = document.querySelector('.header-menu-minicart');
	let miniCartOpen = false;
	let buttonMiniCartClose = document.querySelector('.minicart-mask');
	let body = document.querySelector('body');

	// Attach Modal instance to element
	minicartElement._dialog = minicart;

	if ( headerMenuMinicart ) {
		headerMenuMinicart.addEventListener('click', (event) => {
			event.preventDefault();
			if ( !miniCartOpen ) {
				minicart.show();
			} else {
				minicart.hide();
			}
		});
		buttonMiniCartClose.addEventListener('click', (event) => {
			minicart.hide();
		});
	}
	
	// Track state
	minicart.on('show', function (event) {
		miniCartOpen = true;
		body.classList.add('show-minicart');
		body.classList.remove('show-menu');
	});
	minicart.on('hide', function (event) {
		miniCartOpen = false;
		body.classList.remove('show-minicart');
	});

	// Cart reload
	document.addEventListener("liquid-ajax-cart:request-end", (event) => {
		const { requestState } = event.detail;

		// Update lazyload
		lazyLoadInstance.update();

		// If the "add to cart" request is successful
		if (requestState.requestType === "add" && requestState.responseData?.ok) {
			
			// Show minicart
			minicart.show();

			// Scroll to top
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth",
			});
		}
	});
}

function layout_about() {

	let about = document.querySelector('.layout-about');

	if ( about ) {
		// Submenu
		let aboutMenuItem = about.querySelectorAll('.about-navigation a');
        let header = document.querySelector('.header');
      
		aboutMenuItem.forEach((menuItem, i) => {
			menuItem.addEventListener('click', (event) => {
				event.preventDefault();
				hash = menuItem.href.split('#')[1];
				section = document.querySelector('.about-section[data-name="' + hash + '"]');

                if ( window.innerWidth < 768 ) {
                  offset = section.getBoundingClientRect().top + window.scrollY - header.offsetHeight;
                } else {
                  offset = section.getBoundingClientRect().top + window.scrollY + 1;
                }
              
				if ( section ) {
					window.scrollTo({
						top: offset,
						left: 0,
						behavior: 'smooth',
					});
				}
			});
		});

		// Deep link on load
		if ( window.location.hash ) {
			hash = window.location.hash.split('#')[1];
			section = document.querySelector('.about-section[data-name="' + hash + '"]');
			if ( section ) {
				window.scrollTo({
					top: section.getBoundingClientRect().top + window.scrollY + 1,
					left: 0,
					behavior: 'smooth',
				});
			}
		}
	}
}

function layout_quantity() {

	let quantities = document.querySelectorAll('.quantity');

	quantities.forEach((quantity, i) => {		

		input = quantity.querySelector('.quantity-input');

		// Plus
		quantity.querySelector('.quantity-plus').addEventListener('click', (event) => {
			event.preventDefault();
			quantityValue = parseInt(input.value) ? parseInt(input.value) : 0;
			if ( ( quantityValue + 1 ) <= parseInt(input.max) ) {
				input.value = quantityValue + 1;
			}
		});

		// Minus
		quantity.querySelector('.quantity-minus').addEventListener('click', (event) => {
			event.preventDefault();
			quantityValue = parseInt(input.value) ? parseInt(input.value) : 0;
			if ( quantityValue > 1 ) {
				input.value = quantityValue - 1;
			}
		});
	});
}

function layout_hero() {
	let hero = document.querySelector('.layout-hero');
	if ( hero ) {

        if ( hero.querySelector('.swiper') ) {
    		// Gallery
    		const swiper = new Swiper(hero.querySelector('.swiper'), {
    			loop : true,
    			effect : 'fade',
    			speed : 1000,
    			fadeEffect : {
    				crossFade : true
    			},
    			pagination: {
    				el : '.gallery-pagination',
    				bulletClass : 'gallery-bullet',
    				bulletActiveClass : 'gallery-bullet-active',
    				clickable : true
    			},
    		});
        }

        
	}
}

function layout_product() {
	let product = document.querySelector('.layout-product');
	if ( product ) {

		// Gallery
		const swiper = new Swiper(product.querySelector('.swiper'), {
			loop : true,
			effect : 'fade',
			speed : 3000,
			fadeEffect : {
				crossFade : true
			},
			breakpoints: {
              0: {
                allowSlideNext: true,
                allowSlidePrev: true,
                direction: 'horizontal'
              },
              768: {
                allowSlideNext: false,
                allowSlidePrev: false,
                direction: 'vertical'
              }
            }
		});
	}
}

function layout_video() {
    
    let videos = document.querySelectorAll('.layout-video');

    if (videos) {
        videos.forEach((video, i) => {
            let player = new Plyr(video.querySelector('video'), {
                controls : ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
            });
        });
    }
}

function layout_collection() {

    // Bail on any page without the collection grid (e.g. curated pages without a toolbar)
    if (!document.querySelector('[data-collection-form]')) return;

    let controller = null;
    let debounceId = null;

    // Combined filter + sort state from the single form
    function paramsFromForm() {
        const form = document.querySelector('[data-collection-form]');
        const params = new URLSearchParams();
        new FormData(form).forEach((value, key) => {
            if (value !== '') params.append(key, value);
        });
        return params;
    }

    function apply(params, push = true) {
        const el = document.querySelector('[data-collection-section]');
        if (!el) return;

        const baseUrl = el.dataset.collectionUrl;
        const sectionId = el.dataset.collectionSection;
        const qs = params.toString();
        const cleanUrl = qs ? `${baseUrl}?${qs}` : baseUrl;

        // Cancel any in-flight request so the latest change wins
        if (controller) controller.abort();
        controller = new AbortController();

        el.classList.add('is-loading');

        fetch(`${baseUrl}?section_id=${sectionId}${qs ? '&' + qs : ''}`, { signal: controller.signal })
            .then((response) => response.text())
            .then((html) => {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const fresh = doc.querySelector('[data-collection-section]');
                if (fresh) el.innerHTML = fresh.innerHTML;
                el.classList.remove('is-loading');
                lazyLoadInstance.update();
                if (push) history.pushState({ collection: true }, '', cleanUrl);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') el.classList.remove('is-loading');
            });
    }

    // Sort applies immediately, filters debounce to coalesce rapid toggles
    document.addEventListener('change', (event) => {
        if (!event.target.closest('[data-collection-form]')) return;
        if (event.target.matches('[data-sort]')) {
            apply(paramsFromForm());
        } else if (event.target.matches('[data-filter] input[type="checkbox"]')) {
            clearTimeout(debounceId);
            debounceId = setTimeout(() => apply(paramsFromForm()), 250);
        }
    });

    // Reset link + pagination links: AJAX from their own href, degrade to navigation without JS
    document.addEventListener('click', (event) => {
        const link = event.target.closest('[data-filter-reset], [data-collection-section] .pagination a[href]');
        if (!link) return;
        event.preventDefault();
        apply(new URLSearchParams(new URL(link.href).search));
    });

    // Prevent native submit (Enter key inside the form)
    document.addEventListener('submit', (event) => {
        if (event.target.matches('[data-collection-form]')) event.preventDefault();
    });

    window.addEventListener('popstate', () => {
        apply(new URLSearchParams(window.location.search), false);
    });
}